import QrScanner from 'qr-scanner';
import { createWorker } from 'qr-scanner/qr-scanner-worker.min.js';


// Indica a la librería cómo crear el Worker con el bundler
QrScanner.createWorker = createWorker;


export function makeScanner(videoEl, onResult) {
    return new QrScanner(
        videoEl,
        (result) => {
            const text = typeof result === 'string' ? result : result?.data;
            onResult?.(text);
        },
        {
            preferredCamera: 'environment',
            highlightScanRegion: true,
            highlightCodeOutline: true,
            returnDetailedScanResult: true,
        }
    );
}


export async function listCameras() {
    return await QrScanner.listCameras(true);
}